import { Inject, Injectable, NgZone } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { ScreenOrientationResult, ScreenOrientation } from '@capacitor/screen-orientation';
import { map } from 'rxjs/operators';
import { OrientationLockOptions, OrientationLockType } from '@capacitor/screen-orientation/dist/esm/definitions';
import Env from './../../env';

@Injectable({
    providedIn: 'root'
})
export class ScreenOrientationService {
    private isInLandscapeMode$ = new BehaviorSubject<boolean>(false);
    public isInLandscapeMode = this.isInLandscapeMode$.asObservable();

    private isUpsideDownMode$ = new BehaviorSubject<boolean>(false);
    public isUpsideDownMode = this.isUpsideDownMode$.asObservable();

    public onlyPortraitMode$ = combineLatest([
        this.isUpsideDownMode.pipe(map((isUpsideDown) => !isUpsideDown)),
        this.isInLandscapeMode.pipe(map((isLandscape) => !isLandscape))
    ]).pipe(map(([notUpsideDown, notLandscape]) => notUpsideDown && notLandscape));

    private orientation: any;

    constructor(
        @Inject('ENV') private env: Env,
        @Inject(DOCUMENT) private document: Document,
        private ngZone: NgZone
    ) {
        this.checkOrientation();
    }

    private async checkOrientation() {
        ScreenOrientation.addListener('screenOrientationChange', (orientation: ScreenOrientationResult) => {
            if (orientation) this.checkPortrait(orientation);
        });
        const orientation = await ScreenOrientation.orientation();
        if (orientation) this.checkPortrait(orientation);
    }

    checkPortrait(orientation: ScreenOrientationResult) {
        this.orientation = orientation;
        const isPortrait = /^portrait/.test(this.orientation?.type);
        const isUpsideDown = this.orientation?.type === 'portrait-secondary';

        this.ngZone.run(() => {
            this.isInLandscapeMode$.next(!isPortrait);
            this.isUpsideDownMode$.next(isUpsideDown);
        });
    }

    lock(orientationLockType: OrientationLockType) {
        const options: OrientationLockOptions = { orientation: orientationLockType };
        return ScreenOrientation.lock(options);
    }

    unlock() {
        return ScreenOrientation.unlock();
    }
}
